import React from 'react';
import { Checkbox as MUICheckbox, FormControlLabel } from '@mui/material';
import { ReactComponent as CheckedIcon } from '../assets/images/checkbox-checked-icon.svg';
import { ReactComponent as CheckBlankIcon } from '../assets/images/checkbox-unchecked-icon.svg';

const CCheckbox = ({ label, checked, onChange, name, disabled, className }) => {
  return (
    <FormControlLabel
      className={`CCheckbox ${className}`}
      control={
        <MUICheckbox
          checked={checked}
          onChange={onChange}
          name={name}
          disabled={disabled}
          icon={<CheckBlankIcon />}      // Unchecked icon
          checkedIcon={<CheckedIcon />}  
        />
      }
      label={label}
    />
  );
};

export default CCheckbox;
